import {BROWSER_SIZE_LEVEL} from '@/util/constant.js'
import {getBrowserSizeLevel, reactiveBrowserSize} from '@/util/layout.js'
import {defineStore} from 'pinia'
import {computed, ref} from 'vue'

/**
 * @typedef { import('vue').Ref } Ref
 * @typedef { import('vue').UnwrapRef } UnwrapRef
 */

const useRootStore = defineStore('root', () => {
  const userInfo = ref({})

  const userId = computed(function () {
    return userInfo.value.userId
  })

  const userName = computed(function () {
    return userInfo.value.name
  })

  /**
   * @param {object} value
   */
  function setUserInfo(value) {
    if (!value) {
      userInfo.value = {}
    } else {
      userInfo.value = value
    }
  }

  const menuItems = ref([])

  /**
   *
   * @type {Ref<UnwrapRef<object>>}
   */
  const menuIndexes = ref({})

  /**
   *
   * @type {Ref<UnwrapRef<?string>>}
   */
  const subMenuId = ref(null)

  /**
   *
   * @param {object[]} menuItems
   */
  function initMenuIndexes(menuItems) {
    const tmpMenuIndexes = {}
    menuIndexes.value = initMenuLevelIndexes(menuItems, tmpMenuIndexes)
  }

  /**
   *
   * @param {object[]} menuItems
   * @param {object} tmpMenuIndexes
   * @param {number=} rootMenuId
   */
  function initMenuLevelIndexes(menuItems, tmpMenuIndexes, rootMenuId = 0) {
    for (const menuItem of menuItems) {
      const children = []
      if (menuItem?.children?.length ?? menuItem.children.length > 0) {
        const subRootMenuId = rootMenuId === 0 ? menuItem.resourcesId : rootMenuId
        initMenuLevelIndexes(menuItem.children, tmpMenuIndexes, subRootMenuId)

        for (const subMenuItem of menuItem.children) {
          children.push(tmpMenuIndexes[subMenuItem.resourcesId])
        }
      }

      tmpMenuIndexes[menuItem.resourcesId] = {
        resourcesId: menuItem.resourcesId,
        name: menuItem.name,
        parentResourcesId: menuItem.parentResourcesId,
        isList: menuItem.isList,
        isStatic: menuItem.isStatic,
        rootResourcesId: rootMenuId !== 0 ? rootMenuId : menuItem.resourcesId,
        publicWelfareProjectId: menuItem.publicWelfareProjectId,
        sort: menuItem.sort,
        url: menuItem.url,
        children,
      }
    }
    return tmpMenuIndexes
  }

  const browserSizeLevel = ref(BROWSER_SIZE_LEVEL.none)

  /**
   *
   */
  function initBrowserSizeLevel() {
    browserSizeLevel.value = getBrowserSizeLevel()
    reactiveBrowserSize(() => {
      browserSizeLevel.value = getBrowserSizeLevel()
    })
  }

  return {
    userInfo,
    userId,
    userName,
    setUserInfo,

    menuItems,
    menuIndexes,
    subMenuId,
    initMenuIndexes,

    browserSizeLevel,
    initBrowserSizeLevel,
  }
})

export default useRootStore
